<template>
  
  <div style="width:770px;marin:0 auto;margin-top:10px;margin-left:10px;">

   
          <el-form ref="form" :model="form" label-width="120px" v-loading="loading" :rules="rules">
            
            <table class="table table-bordered myTable ">
              <tr>
                <td colspan="2">
                  <el-form-item  class="mb-0 formItem2">
                    <div class="d-flex align-items-center">
                      <span class="mr-2" style="margin-left:-110px">{{$t('newAdd.일괄생성')}}</span>
             <el-checkbox true-label="1" false-label="0" v-model="pi" style="margin-top: 8px;vertical-align: middle;"></el-checkbox> 
             <div v-if="this.pi==true"> 
               <el-input v-model="mins" class="mr-1 ml-1" type="number" maxlength="2" style="width: 70px;" placeholder="1"></el-input>  ~  <el-input v-model="maxs"  maxlength="2" class="ml-1  mr-1" type="number" style="width: 70px;" placeholder="30"></el-input> 
                <span class="ml-1 mr-1">번호앞에 0</span><el-select v-model="zerocc" :placeholder="$t('searchText.타이틀선택')" size="mini"  style="width: 120px;">
               <el-option
                      v-for="item in zerocclist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>     
              </div> 
            </div>
          </el-form-item>
                </td>
              </tr>
                <tr>

                  <td width="50%">
                      <el-form-item :label="$t('tableText.총판선택')" prop="boss" class="mb-0 formItem">
                      <el-select v-model="form.boss" :placeholder="$t('searchText.타이틀선택')" size="mini" prop="boss" filterable>
                       <el-option
                              v-for="item in bubonlist"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                      </el-select>
                    </el-form-item>
                  
                  </td>
                  <td>
                        <el-form-item :label="$t('msg.공베팅')" v-if="this.sitetype=='4'" prop="shop_name" class="mb-0 formItem">
                        <el-input v-model="form.cash_b"></el-input>
                        </el-form-item>
                  
                  </td>
                </tr>
                 <tr>
                 
                  <td>
                      
                 

                        <el-form-item :label="$t('nav.아이디')"  prop="mem_id" class="mb-0 formItem">
                      <el-input v-model="form.mem_id" class="mr-1 w-50" ></el-input>
                       <el-button type="primary" size="mini" plain @click="reConfirm">{{$t('msg.확인')}}</el-button>
                    </el-form-item>
                  </td>
                   <td>
                      <el-form-item :label="$t('tableText.매장이름')" prop="shop_name" class="mb-0 formItem">
                        <el-input v-model="form.shop_name"></el-input>
                      </el-form-item>
                   
                  </td>
                </tr>
                 <tr>
                  <td>
                    <el-form-item :label="$t('tableText.사용자암호')" :prop="editIndex===-1 ? 'mem_pw' :'empty'" class="mb-0 formItem">
                      <el-input v-model="form.mem_pw"></el-input>
                    </el-form-item>
                    
                  </td>
                  <td>
                      <el-form-item :label="$t('msg.닉네임')" prop="mem_name" class="mb-0 formItem">
                          <el-input v-model="form.mem_name"></el-input>
                        </el-form-item>
                  
                  </td>
                </tr>
                 <tr v-if=" (this.sitetype==='1' || this.sitetype==='3' || this.sitetype==='4') && this.power==='1' ">
                  <td>
                        <el-form-item :label="$t('msg.파워볼일반')" class="mb-0 formItem" prop="event_loing_recom">
                          <el-input v-model="form.event_loing_recom"></el-input>
                        </el-form-item>
                  </td>
                  <td>
                    <div class="d-flex">
                   <el-form-item :label="$t('msg.파워볼조합')" class="mb-0 formItem" prop="event_loing_group_recom">
                      <el-input v-model="form.event_loing_group_recom"></el-input>
                    </el-form-item>
                   <!-- <el-form-item label="사다리 일반" class="mb-0 formItem" prop="event_loing_recom_s">
                      <el-input v-model="form.event_loing_recom_s"></el-input>
                    </el-form-item>-->
                  </div>
                  </td>
                </tr>
                <tr  v-if="this.sitetype==='4'">
                  <td>
                       <el-form-item :label="$t('msg.카지노롤링')" class="mb-0 formItem" prop="event_loing_recom_e">
                          <el-input v-model="form.event_loing_recom_e"></el-input>
                        </el-form-item>
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.슬롯롤링')" class="mb-0 formItem" prop="event_loing_recom_slot">
                        <el-input v-model="form.event_loing_recom_slot"></el-input>
                      </el-form-item>
                  </td>
                </tr>

                 <template v-if="this.sitetype==='4' && this.rosing==='1'">
                <tr>
                  <td colspan="2">
                     <div class="d-flex" style="margin-top:0.5rem">
                     <el-form-item :label="$t('msg.바카라루징')" prop="pc_e" class="mb-0 bl">
                        <el-input v-model="form.pc_e"></el-input>
                      </el-form-item>
                       <el-form-item :label="$t('msg.슬롯루징')" prop="pc_slot" class="mb-0 bc">
                      <el-input v-model="form.pc_slot"></el-input>
                    </el-form-item>
                     <el-form-item :label="$t('newAdd.파루징')" v-if="this.power==='1'" prop="pc_p" class="mb-0 bc-ml ">
                      <el-input v-model="form.pc_p"></el-input>
                    </el-form-item>
                    </div>

                  </td>
                </tr>
              </template>


                 <tr>
                  <td>
                     <el-form-item :label="$t('msg.가입코드')"  class="mb-0 formItem" v-if="this.pi==false">
                       <el-tooltip class="item" effect="dark" content="게임사이트(도메인)에서 가입하실데 입력하는 가입코드입니다." placement="top">
                                <el-button icon="el-icon-question" circle style="padding:0;position:absolute;margin-left: -40px;z-index: 10;background: transparent;border:none;font-size: 18px !important;color:#000"></el-button>
                      </el-tooltip>
                      <el-input
                          type="textarea"
                          :autosize="{ minRows: 1, maxRows: 1}"
                          :placeholder="$t('msg.가입시코드')"
                          v-model="form.reg_code" style="min-height: 33px; height: 33px;">
                        </el-input>
                     
                    </el-form-item>
                       
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.핸드폰')" class="mb-0 formItem">
                          <el-input v-model="form.mem_hp"></el-input>
                        </el-form-item>
                    
                  </td>
                </tr>
                 <tr>
                  <td>
                    <el-form-item :label="$t('tableText.은행명')" class="mb-0 formItem">
                      <el-input v-model="form.mem_bankcode"></el-input>
                    </el-form-item>
                         
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.계좌번호')" class="mb-0 formItem">
                          <el-input v-model="form.mem_banknum"></el-input>
                        </el-form-item>
                   
                  </td>
                </tr>
                 <tr>
                  <td>  
                    <el-form-item :label="$t('tableText.예금주')" class="mb-0 formItem" prop="mem_bankname">
                        <el-input v-model="form.mem_bankname"></el-input>
                      </el-form-item>
                      
                  </td>
                  <td>
                     <el-form-item :label="$t('tableText.출금비번')" class="mb-0 formItem" :prop="editIndex===-1 ? 'mem_jumin' :'empty'">
                          <el-input v-model="form.mem_jumin"></el-input>
                        </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('tableText.회수가능')" v-if="this.sitetype=='4'" class="mb-0 formItem" prop="recy">
                        <el-radio-group v-model="form.recy" class="mt-2">
                          <el-radio label="1">on</el-radio>
                          <el-radio label="0">off</el-radio>
                        
                        </el-radio-group>
                      </el-form-item>

                      <el-form-item :label="$t('msg.루징')" prop="pc" v-if="this.sitetype=='2' && this.rosing=='1'" class="mb-0 formItem">
                      <el-input v-model="form.pc"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.상태')" class="mb-0 formItem">
                      <el-select v-model="form.status" size="mini">
                           <el-option
                                  v-for="item in bubonOptlist"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                    </el-form-item>
                  </td>
                </tr>

  </table>
          </el-form>
         <div class="d-flex" style="justify-content:center">
              <el-button @click="shopClose">{{$t('msg.취소')}}</el-button> 
            <el-button type="primary" @click="submit" :disabled="disabled">{{$t('msg.확인')}}</el-button>
         </div> 
          
  </div>
</template>
<script>
 
  export default{
     components: {
     
      
    
    },
    props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       layerid:{
        type:String,
        default:""
      },
       idx:{
        type:Number,
        default:""
      },
     eindex:{
        type:Number,
        default:""
      },
    },
    computed: {
          
          
            
        },
      data(){
        return{
            bubonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],
            disabled:false,
          form:{
            cash_b:0,
             pc:'',
             pc_e:'',
              pc_p:'',
            pc_slot:'',
            recy:'0',
            shop_name:'',
             boss:'',
            reg_code:'',
            mem_pw:'',
            mem_name:'',
            mem_id:'',
             id:'',
            event_loing_recom:'',
            event_loing_recom_s:'',
            event_loing_group_recom:'',
             event_loing_recom_e:'',
            event_loing_recom_slot:'',
              mem_banknum:'',
            mem_bankcode:'',
            mem_bankname:'',
            mem_jumin:'',
            mem_hp:'',
           
            status:'1',
          },
           bubonOptlist:[{
                label:this.$i18n.t("msg.정상"),
                value:'1'
            },
            {
                label:this.$i18n.t("msg.차단"),
                value:'0'
            }
            
            ],
            zerocclist:[
            {
              label: this.$i18n.t("newAdd.없음"),
              value: '0',
            },
             {
              label: "하나",
              value: '1',
            }, {
              label: "두개",
              value: '2',
            }
            ],
          zerocc:'0',
          pi:false,
          editIndex:-1,
           mins:'1',
          maxs:'30',
          back_id:'',
          boss:'',
          tips:'',
          newDate:'',
          v:'',
           domain:window.sessionStorage.getItem('domain'),
           admin_id:window.sessionStorage.getItem('admin_id'),
           power:window.sessionStorage.getItem('power'),
            sitetype:window.sessionStorage.getItem('sitetype'),
            rosing:window.sessionStorage.getItem('rosing'),
            loading:false,
              rules: {
                  mem_jumin:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_e:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_slot:[{ required: true, message: '', trigger: 'blur'}],
                   recy:[{ required: true, message: '', trigger: 'blur'}],
                  shop_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankname:[{ required: true, message: '', trigger: 'blur'}],
                  reg_code:[{ required: true, message: '', trigger: 'blur'}],
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  mem_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_pw:[{ required: true, message: '', trigger: 'blur'}],
                  boss:[{ required: true, message: '', trigger: 'blur'}],
                  pc_slot:[{ required: true, message: '', trigger: 'blur'}],
                  pc_e:[{ required: true, message: '', trigger: 'blur'}],
                },
              
         
           
           
           
          
        }
      },
      created() {
         // this.info.id父组件传给子组件的id值
        
         console.log(this.info.id)
         this.fetchManage(this.info.id);
        

          
             
    },
    
      methods:{
         submit(){
             
              let token=window.sessionStorage.getItem('user');
                this.loading =true
              this.$refs.form.validate((e)=>{
             if(!e) return;
           
            
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/sp_up',
                      data:{
                          shop_name:this.form.shop_name,
                          reg_code:this.form.reg_code,
                          mem_pw:this.form.mem_pw,
                           cash_b:this.form.cash_b,
                           boss:this.form.boss,
                          mem_name:this.form.mem_name,
                          id:this.form.id,
                          mem_id:this.form.mem_id,
                          event_loing_recom:this.form.event_loing_recom,
                          event_loing_recom_s:this.form.event_loing_recom_s,
                          event_loing_recom_e:this.form.event_loing_recom_e,
                          event_loing_recom_slot:this.form.event_loing_recom_slot,
                          mem_banknum:this.form.mem_banknum,
                          mem_bankcode:this.form.mem_bankcode,
                          mem_bankname:this.form.mem_bankname,
                          mem_jumin:this.form.mem_jumin,
                          mem_hp:this.form.mem_hp,
                          event_loing_group_recom:this.form.event_loing_group_recom,
                          status:this.form.status,
                          recy:this.form.recy,
                          pc_slot:this.form.pc_slot,
                          pc_e:this.form.pc_e,
                          pc_p:this.form.pc_p,
                          pc:this.form.pc,
                           pi:this.pi,
                          mins:this.mins,
                          maxs:this.maxs,
                          zerocc:this.zerocc
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.$layer.close(this.layerid)
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                      this.$parent.getList()  
                      this.disabled = false
                       this.loading =false
                    }else
                    {
                       //this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'warning'
                      })
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

            
            })
              
            
        },
        reConfirm(){
               let token=window.sessionStorage.getItem('user');

               if(this.form.mem_id=='')
               {
                    this.$message.error('id error')
                    return;
               }
               this.$axios({
                    method:'post',
                    url:this.domain+'/admin/id_check',
                    data:{
                       mem_id:this.form.mem_id,
                        pi:this.pi,
                          mins:this.mins,
                          maxs:this.maxs,
                          zerocc:this.zerocc
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                         this.$message({
                          message:response.data.msg,
                          type: 'success'
                        });

                         
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
         openShopModel(id){

          if(id=='합계')
          {
             return;
          }

           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: shopDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            success: function(layero, index) {
              //对加载后的iframe进行宽高度自适应
                //layer.iframeAuto(index);
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['1100px','600px'],
           
        });
        
        },

    
        fetchManage(id){
          console.log(id)
          let token=window.sessionStorage.getItem('user');


           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/zplist_select',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                 console.log(response.data.data);

                 let newids=[];


           response.data.data.forEach(item=>{
            let obj={};
            obj.label=item.agent_name
            obj.value=item.code
    
            newids.push(obj);

            //console.log('obj',obj);
           });


                this.bubonlist=newids

                 
                  
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
        
            //修改
       
             this.loading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/sp?id='+this.idx,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                  this.loading = false
                  let item = response.data.data
                  console.log('data==',item)
                  
                    this.form = {

                          shop_name:item.shop_name,
                          reg_code:item.reg_code,
                          boss:item.boss,
                          mem_pw:item.mem_pw,
                          mem_name:item.mem_name,
                          id:item.idx,
                          mem_id:item.mem_id,
                          event_loing_recom:item.event_loing_recom,
                          event_loing_recom_s:item.event_loing_recom_s,
                          mem_banknum:item.mem_banknum,
                          mem_bankcode:item.mem_bankcode,
                          mem_bankname:item.mem_bankname,
                          mem_jumin:item.mem_jumin,
                          mem_hp:item.mem_hp,
                          event_loing_group_recom:item.event_loing_group_recom,
                           event_loing_recom_e:item.event_loing_recom_e,
                           event_loing_recom_slot:item.event_loing_recom_slot,
                          cash_b:item.cash_b,
                          //bubon_select: item.boss,
                          status:item.status,
                          pc_slot:item.pc_slot,
                          pc_e:item.pc_e,
                          pc_p:item.pc_p,
                          pc:item.pc,
                          recy:item.recy

                }
                this.editIndex = this.eindex
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
          
           
          

        },
      
      searchEvent(){
        this.fetchManage()
      },
      shopClose(){
         this.$layer.close(this.layerid);
      },

      }
  }
</script>
<style scoped>

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }

 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 >>>.el-textarea__inner{
  height:33px;
 }
</style>


// WEBPACK FOOTER //
// src/components/common/shop-edit.vue